import React, { useState, useEffect } from "react";
import QbankCard from "./QbankCard";
import "./QbankContent.scss";
import { Link } from "react-router-dom";
import PATH from "../../constants/routes";

let qbankListPrototype = [
  {
    unitTitle: "Introduction",
    topicQbankLists: [
      { id: "topicIdxyz", title: "Introduction Gametogenesis", rating: 5.0, questionLeft: 10 },
      { id: "topicIdxyz", title: "Development timeline ", rating: 4.0, questionLeft: 2 },
      { id: "topicIdxyz", title: "Development Gametogenesis", rating: 2.0, questionLeft: 4 },
      { id: "topicIdxyz", title: "Development timeline and Gametogenesis", rating: 5.0, questionLeft: 10 },
    ],
  },
  {
    unitTitle: "Development of something",
    topicQbankLists: [
      { id: "topicIdxyz", title: "Introduction Gametogenesis", rating: 5.0, questionLeft: 10 },
      { id: "topicIdxyz", title: "Development timeline ", rating: 4.0, questionLeft: 2 },
      { id: "topicIdxyz", title: "Development Gametogenesis", rating: 2.0, questionLeft: 4 },
      { id: "topicIdxyz", title: "Development timeline and Gametogenesis", rating: 5.0, questionLeft: 10 },
    ],
  },
  {
    unitTitle: "Mastering the content",
    topicQbankLists: [
      { id: "topicIdxyz", title: "Introduction Gametogenesis", rating: 5.0, questionLeft: 10 },
      { id: "topicIdxyz", title: "Development timeline ", rating: 4.0, questionLeft: 2 },
      { id: "topicIdxyz", title: "Development Gametogenesis", rating: 2.0, questionLeft: 4 },
      { id: "topicIdxyz", title: "Development timeline and Gametogenesis", rating: 5.0, questionLeft: 10 },
    ],
  },
];

export default function QbankContent() {
  const [unitsQbank, setUnitsQbank] = useState(qbankListPrototype);

  const renderQbanks = () => {
    return unitsQbank.map((unit, index) => {
      return (
        <div key={index} className="unit_container">
          <h3 className="unit_title">{unit.unitTitle}</h3>
          <div className="qbank_container">
            {unit.topicQbankLists.map((topicQbank, index) => {
              return (
                <Link key={index} to={`${topicQbank.id}/${PATH.QUIZ_STATUS_LINK}`}>
                  <QbankCard />
                </Link>
              );
            })}
          </div>
        </div>
      );
    });
  };
  return <div className="unit_qbank_container">{renderQbanks()}</div>;
}
